/**
 * How long a clipping has left before the TTL index drops it.
 *
 * A clipping is deleted 90 days after it was made and nothing tells its owner, so
 * 「내 클리핑」 has to count down to it. Pure, so the arithmetic is checked without a
 * DOM — the numbers are the whole point of the row.
 */

const DAY_MS = 24 * 60 * 60 * 1000

/** Below this many days left, the row says so instead of just showing a number. */
export const EXPIRY_WARNING_DAYS = 7

/**
 * Whole days until a clipping expires.
 *
 * Rounded up, so `1` means "some time today or tomorrow" rather than "gone". Zero or
 * less means the TTL has already passed and Mongo has not swept it yet — its sweep
 * runs on its own schedule, roughly once a minute, not at the instant of expiry.
 */
export function daysUntilExpiry(expiresAt: string, now: number = Date.now()): number {
  return Math.ceil((new Date(expiresAt).getTime() - now) / DAY_MS)
}

export function formatCreatedAt(createdAt: string): string {
  return new Date(createdAt).toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
